<template>
  <Admin style="background: white">
    <v-main class="wrapper">
      <v-card outlined class="pa-4 tw-bg-white" style="margin: 10px">
        <v-container fluid>
          <!-- Title Section -->
          <v-row>
            <v-col cols="12" class="text-center mb-4">
              <h2 class="font-weight-bold">รายงานการนำเข้าเอกสาร</h2>
            </v-col>
          </v-row>

          <!-- Filters Section -->
          <v-container fluid>
            <v-row
              justify="space-between"
              align="center"
              class="text-center mb-4"
            >
              <!-- Date for both PO and SO  -->
              <v-col cols="auto" class="text-center font-weight-bold">
                <p>Date</p>
              </v-col>
              <!-- Start Date Picker -->
              <div class="col-12 col-sm-6 col-md-3">
                <v-menu
                  ref="startDateMenu"
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  content-class="responsive-width"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedStartDate"
                      label="วันที่เริ่มต้น"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    @input="saveStartDate"
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </div>

              <div class="col-12 col-sm-4 col-md-3">
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndDate"
                      label="วันที่สิ้นสุด"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    @input="saveEndDate"
                    :min="minToDate"
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </div>

              <!-- Company Autocomplete -->
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="selectedCompany"
                  label="บริษัท"
                  :items="companyList"
                  outlined
                  dense
                  prepend-icon="mdi-office-building"
                  style="background: white"
                ></v-autocomplete>
              </v-col>

              <!-- Reset Button -->
              <v-col
                cols="12"
                sm="6"
                md="2"
                class="text-left"
                style="margin-top: -25px"
              >
                <v-btn
                  class="btn-submit"
                  color="#f05d5d"
                  text
                  @click="resetFilters"
                >
                  <v-icon small>mdi-restart</v-icon>
                  <b>รีเซ็ตค่า</b>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

          <!-- Job Status and Chart Section -->
          <v-row>
            <!-- Job Status Summary -->
            <v-col cols="12" md="6">

              <h3
                class="mb-3"
                style="text-align: left; font-weight: bold; padding-left: 10px"
              >
                Job Status
              </h3>
              <v-row>
                <!-- Left Column -->
                <v-col cols="6">
                  <div
                    class="status-item"
                    style="
                      border: 1px solid #ccc;
                      padding: 8px;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    "
                  >
                    <router-link
                      :to="
                        generateLink(
                          companyID,
                          selectedCompany,
                          'SUCCESS',
                          startDate,
                          endDate
                        )
                      "
                      class="status-label"
                      style="color: #0fb45f; text-decoration: none"
                    >
                      SUCCESS:
                    </router-link>
                    <span class="status-value">{{ jobStatus.success }}</span>
                  </div>
                  <div
                    class="status-item"
                    style="
                      border: 1px solid #ccc;
                      padding: 8px;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    "
                  >
                    <router-link
                      :to="
                        generateLink(
                          companyID,
                          selectedCompany,
                          'PENDING_APPROVAL',
                          startDate,
                          endDate
                        )
                      "
                      class="status-label pending"
                      style="text-decoration: none"
                    >
                      PENDING:
                    </router-link>
                    <span class="status-value">{{ jobStatus.pending }}</span>
                  </div>
                  <div
                    class="status-item"
                    style="
                      border: 1px solid #ccc;
                      padding: 8px;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    "
                  >
                    <router-link
                      :to="
                        generateLink(
                          companyID,
                          selectedCompany,
                          'ERROR',
                          startDate,
                          endDate
                        )
                      "
                      class="status-label"
                      style="color: rgb(173, 15, 1); text-decoration: none"
                    >
                      ERROR:
                    </router-link>
                    <span class="status-value">{{ jobStatus.error }}</span>
                  </div>
                </v-col>

                <!-- Right Column -->
                <v-col cols="6">
                  <div
                    class="status-item"
                    style="
                      border: 1px solid #ccc;
                      padding: 8px;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    "
                  >
                    <router-link
                      :to="
                        generateLink(
                          companyID,
                          selectedCompany,
                          'POSTING',
                          startDate,
                          endDate
                        )
                      "
                      class="status-label posting"
                      style="text-decoration: none"
                    >
                      POSTING:
                    </router-link>
                    <span class="status-value">{{ jobStatus.posting }}</span>
                  </div>
                  <div
                    class="status-item"
                    style="
                      border: 1px solid #ccc;
                      padding: 8px;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    "
                  >
                    <router-link
                      :to="
                        generateLink(
                          companyID,
                          selectedCompany,
                          'WARNING',
                          startDate,
                          endDate
                        )
                      "
                      class="status-label"
                      style="color: rgb(255, 178, 76); text-decoration: none"
                    >
                      WARNING:
                    </router-link>
                    <span class="status-value">{{ jobStatus.warning }}</span>
                  </div>
                  <div
                    class="status-item"
                    style="
                      border: 1px solid #ccc;
                      padding: 8px;
                      margin-bottom: 10px;
                      border-radius: 4px;
                    "
                  >
                    <router-link
                      :to="
                        generateLink(
                          companyID,
                          selectedCompany,
                          'SHOW_ALL',
                          startDate,
                          endDate
                        )
                      "
                      class="status-label"
                      style="text-decoration: none"
                    >
                      PO All Status:
                    </router-link>
                    <span class="status-value">{{ jobStatus.totalPO }}</span>
                  </div>
                  <div
                    class="status-all"
                    style="
                      padding: 8px;
                      margin-bottom: 10px;
                      border-radius: 4px;
                      text-align: right;
                    "
                  >
                    <p
                      class="status-value"
                      style="margin: 0; text-align: right"
                    >
                      ALL STATUS: {{ jobStatus.totalJobs }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <!-- Pie Chart -->
            <v-col cols="12" md="6">
              <v-card outlined class="pa-4">
                <h3 class="mb-3" style="font-weight: bold; text-align: center">
                  JOB HISTORY
                </h3>
                <pie-chart
                  :chartData="computedPieChartData"
                  :options="chartOptions"
                  :selected-company="selectedCompany"
                  :start-date="startDate"
                  :end-date="endDate"
                  :company-i-d="companyID"
                  :company-list="companyList"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import PieChart from "@/components/admin/dashboard/pie.vue";
import fc from "@/firebaseConfig";
import { INVOICE_STATUS } from "@/libs/libConstant";

export default {
  data() {
    return {
      companyID: this.$route.params.companyId,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      selectedCompany: "ALL",
      companyList: [],
      jobStatus: {
        success: 0,
        posting: 0,
        pending: 0,
        error: 0,
        warning: 0,
        totalJobs: 0,
        totalPO: 0,
      },
      pieChartData: {
        labels: ["SUCCESS", "PENDING", "WARNING", "POSTING", "ERROR"],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "#0fb45f",
              "#4794eb",
              "rgb(255, 178, 76)",
              "rgb(159, 152, 255)",
              "rgb(173, 15, 1)",
            ],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            enabled: false, // ปิด tooltip กรณีไม่มีข้อมูล
          },
          legend: {
            display: false, // ซ่อน legend กรณีไม่มีข้อมูล
          },
        },
      },
    };
  },
  components: {
    Admin,
    PieChart,
  },
  methods: {

    async getPurchaseOrder() {
      const companyID = this.$route.params.companyId;
      let query = fc.db.collection(`Companies/${companyID}/PurchaseOrders`);
      let querySO = fc.db.collection(`Companies/${companyID}/PurchaseOrders`);

      if (this.selectedCompany !== "ALL") {
        query = query.where("CompanyCode", "==", this.selectedCompany);
        querySO = querySO.where("CompanyCode", "==", this.selectedCompany);
      }

      query = query.where("Status", "in", INVOICE_STATUS.PO)
      querySO = querySO.where("Status", "==", INVOICE_STATUS.SUCCESS);


      if (this.startDate && this.endDate) {

        const startDate = new Date(this.startDate);
        startDate.setHours(0)
        const endDate = new Date(this.endDate);
        endDate.setHours(23, 59, 59, 999)

        query = query.where("PODate", ">=", startDate);
        query = query.where("PODate", "<=", endDate);
        querySO = querySO.where("SODate", ">=", startDate);
        querySO = querySO.where("SODate", "<=", endDate);
      }

      const DocPurchase = await query
        .get()
        .then((r) => r.docs.map((doc) => doc.data()));

        const DocPurchaseSO = await querySO
        .get()
        .then((r) => r.docs.map((doc) => doc.data()));

        console.log("DocPurchase<< ", DocPurchase)
        console.log("DocPurchaseSO<< ", DocPurchaseSO)

      const removeDupplicate = new Set([...DocPurchase, ...DocPurchaseSO])
      const combinedDocPurchase = Array.from(removeDupplicate)


      console.log("combinedDocPurchase:: ", combinedDocPurchase)

      const statusCount = combinedDocPurchase.reduce(
        (acc, doc) => {
          if (
            doc.Status &&
            doc.Status !== "FETCHING" &&
            doc.Status !== "NEW" &&
            doc.Status !== "DELETED"
          ) {
            acc[doc.Status] = (acc[doc.Status] || 0) + 1;
          }
          return acc;
        },
        { SUCCESS: 0, WARNING: 0, POSTING: 0, PENDING: 0, ERROR: 0 }
      );

      // console.log("statusCount", statusCount);
      const totalPO = DocPurchase.reduce((count, doc) => {
        if (
          doc.Status &&
          doc.Status !== "SUCCESS" &&
          doc.Status !== "DELETED" &&
          doc.Status !== "NEW"&&
          doc.Status !== "FETCHING"
        ) {
          return count + 1; // Increment count for valid statuses
        }
        return count;
      }, 0);

      this.jobStatus = {
        success: statusCount.SUCCESS || 0,
        warning: statusCount.WARNING || 0,
        posting: statusCount.POSTING || 0,
        pending: statusCount.PENDING_APPROVAL || 0,
        error: statusCount.ERROR || 0,
        totalPO: totalPO,
        totalJobs: Object.values(statusCount).reduce(
          (sum, val) => sum + val,
          0
        ),
      };

      this.pieChartData.datasets[0].data = [
        this.jobStatus.success,
        this.jobStatus.pending,
        this.jobStatus.warning,
        this.jobStatus.posting,
        this.jobStatus.error,
      ];
    },


    async fetchCompanyList() {
      const companyID = this.$route.params.companyId;
      const querySnapshot = await fc.db
        .collection(`Companies/${companyID}/PurchaseOrderSettings`)
        .where("isActive", "==", true)
        .get();

      this.companyList = querySnapshot.docs.map((doc) => {
        return {
          text: doc.data().vendorName || doc.id, // vendorName หรือ doc.id
          value: doc.id, // ใช้ doc.id เป็น value
        };
      });

      // เพิ่ม "ALL" เป็นค่าเริ่มต้น
      this.companyList.unshift({ text: "ALL", value: "ALL" });
    },

    generateLink(companyID, selectedCompany, status, startDate, endDate) {
      // Format startDate and endDate if they are provided
      const formattedStartDate = startDate
        ? encodeURIComponent(new Date(startDate).toISOString())
        : null;
      const formattedEndDate = endDate
        ? encodeURIComponent(new Date(endDate).toISOString())
        : null;

      let baseURL = "";

      if (status === "SUCCESS") {
        if (selectedCompany === "ALL") {
          baseURL = `/${companyID}/documentsoai?status=${status}`;
        } else {
          const selectedDoc = this.companyList.find((company) => {
            return company.value.trim() === selectedCompany.trim();
          });
          const companyValue = selectedDoc?.value || this.selectedCompany || "";
          baseURL = `/${companyID}/DocumentSOAIVendor/${companyValue}?status=${status}`;
        }
      } else {
        if (selectedCompany === "ALL") {
          baseURL = `/${companyID}/documentpoai?status=${status}`;
        } else {
          const selectedDoc = this.companyList.find((company) => {
            return company.value.trim() === selectedCompany.trim();
          });
          const companyValue = selectedDoc?.value || this.selectedCompany || "";
          baseURL = `/${companyID}/DocumentPOAIVendor/${companyValue}?status=${status}`;
        }
      }

      // Conditionally append startDate and endDate if they are defined
      const queryParams = [];
      if (formattedStartDate)
        queryParams.push(`startDate=${formattedStartDate}`);
      if (formattedEndDate) queryParams.push(`endDate=${formattedEndDate}`);

      if (queryParams.length > 0) {
        baseURL += `&${queryParams.join("&")}`;
      }

      return baseURL;
    },

    handleChartClick(event) {
      this.$emit("chartClick", event);
      // Add custom logic here
    },

    saveStartDate() {
      this.startDateMenu = false;
    },
    saveEndDate() {
      this.endDateMenu = false;
    },
    formattedDate(date) {
      if (!date) return "";
      return new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(date));
    },
    resetFilters() {
      this.startDate = null;
      this.endDate = null;
      this.selectedCompany = "ALL";
      this.getPurchaseOrder();
    },
  },
  computed: {
    formattedStartDate() {
      return this.formattedDate(this.startDate);
    },
    formattedEndDate() {
      return this.formattedDate(this.endDate);
    },
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.startDate);
      minDate.setDate(minDate.getDate());
      return minDate.toISOString().substr(0, 10); // Format as "YYYY-MM-DD"
    },
    computedPieChartData() {
      if (
        !this.pieChartData.datasets ||
        this.pieChartData.datasets.length === 0 ||
        this.pieChartData.datasets[0].data.every((value) => value === 0)
      ) {
        return {
          labels: ["No Data"],
          datasets: [
            {
              data: [1], // ให้เต็มวงกลม
              backgroundColor: ["#d3d3d3"], // สีเทา
            },
          ],
        };
      }
      return this.pieChartData;
    },
  },
  watch: {
    selectedCompany: "getPurchaseOrder",
    startDate(newVal, oldVal){
      this.endDate = newVal
    },
    endDate: "getPurchaseOrder",
  },
  created() {
    this.getPurchaseOrder();
    this.getPurchaseOrder();
    this.fetchCompanyList();
    this.generateLink();
  },
};
</script>

<style lang="scss" scoped>
/* General Variables */
$success-color: #0fb45f;
$warning-color: rgb(255, 178, 76);
$error-color: rgb(173, 15, 1);
$pending-color: rgb(97, 163, 255);
$posting-color: rgb(159, 152, 255);

h2 {
  color: #333;
  font-size: 1.8rem;
}

.status-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.status-all {
  font-weight: bold;
  margin-bottom: 8px;
}

.status-label {
  font-weight: bold;
  font-size: 0.9rem;
}
.status-label:hover {
  text-decoration: underline !important;
}

.status-value {
  font-size: 0.9rem;
}

.v-card {
  background-color: #f9f9f9;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.warning {
  color: $warning-color;
}

.pending {
  color: $pending-color;
}

.error {
  color: $error-color;
}

.posting {
  color: $posting-color;
}

.responsive-width {
  z-index: 1000 !important;
}
.v-text-field {
  width: 290px; /* เปลี่ยนค่าตามต้องการ */
}
</style>
